import React, { useEffect, useState } from 'react';

import { usePeriodPickerQueries } from '@entities/period-picker/lib/usePeriodPickerQueries';
import { PickerTitle } from '@entities/period-picker/model/picker-title.enum';
import { generateId } from '@shared/helpers';
import { useScreenSize } from '@shared/hooks';
import { Skeleton } from '@shared/ui';

import cls from './PeriodPicker.module.css';
import { PeriodPickerItem } from './PeriodPickerItem';
import { pickersData, pickerDataLessThen1500 } from '../../model/pickers-data';
import { TPickerId } from '../../model/types';

interface IPeriodPickerProps {
    handleClickPicker: (picker: TPickerId) => void;
    periodValue: string;
    onChangePeriod: (value: string) => void;
    onChangeRangeQueryValues: (raw?: string) => void;
    isPending: boolean;
}

export const PeriodPicker = ({
    handleClickPicker,
    periodValue,
    onChangePeriod,
    onChangeRangeQueryValues,
    isPending,
}: IPeriodPickerProps) => {
    const { periodPickerQueryValue: currentPickerId } = usePeriodPickerQueries();
    const { width: windowSize } = useScreenSize();
    const [pickersDataForRender, setPickersDataForRender] = useState(pickersData);

    useEffect(() => {
        if (windowSize <= 1500) {
            setPickersDataForRender(pickerDataLessThen1500);
            return;
        }

        setPickersDataForRender(pickersData);
    }, [windowSize]);

    if (isPending) {
        return (
            <ul className={cls.PeriodList}>
                {Array.from({ length: 6 }).map(() => (
                    <Skeleton
                        key={generateId(true)}
                        height={24}
                        border="8px"
                        classes={cls.SkeletonPicker}
                    />
                ))}
            </ul>
        );
    }

    return (
        <ul className={cls.PeriodList}>
            {pickersDataForRender.map((picker) => {
                const isInput = picker.id === PickerTitle.CHOOSE_PERIOD;
                return (
                    <PeriodPickerItem
                        key={picker.id}
                        itemType={isInput ? 'input' : 'button'}
                        itemData={picker}
                        isPicked={picker.id === currentPickerId}
                        onClickHandler={handleClickPicker}
                        {...(isInput && {
                            periodValue,
                            onChangePeriod,
                            onChangeRangeQueryValues,
                        })}
                    />
                );
            })}
        </ul>
    );
};
